export default "__VITE_ASSET__bRd6Ppdx__"